import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { CurrencyEnums } from "models/enums";
import { FormHandles } from "models/propTypes/genericFormProps";
import { CashReconciliationDetailsFormContainerProps } from "models/propTypes/cashReconciliationPropTypes";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion
//#region  components
import { CashReconciliationDetailsForm } from "components/cashReconciliation";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const CashReconciliationDetailsFormContainer: ForwardRefRenderFunction<
  FormHandles,
  CashReconciliationDetailsFormContainerProps
> = (props, ref) => {
  const { cashRegister } = props;

  const getItemGroupValues = (items?: WintSuperkollAPIModel.CashReconciliationItemInstance[]) => {
    const defaultValues = {} as any;
    let total = 0;

    items?.forEach((res, index) => {
      defaultValues[`${res.category}_${index}`] = LocalizationHelperInstance.getFormattedCurrency(
        res.amount,
        CurrencyEnums.CurrencyCode.SEK
      );
      total += res.amount;
    });

    return { defaultValues, total };
  };

  const getDefaultValues = () => {
    let def = {} as any;

    const { defaultValues: salesItems, total: salesTotal } = getItemGroupValues(
      cashRegister?.items?.filter(
        (item) => item.category === WintSuperkollAPIModel.CashReconciliationItemCategory.Sales
      )
    );

    const { defaultValues: paymentMethodItems, total: paymentMethodsTotal } = getItemGroupValues(
      cashRegister?.items?.filter(
        (item) => item.category === WintSuperkollAPIModel.CashReconciliationItemCategory.PaymentMethod
      )
    );

    const { defaultValues: otherItems, total: otherTotal } = getItemGroupValues(
      cashRegister?.items?.filter(
        (item) => item.category === WintSuperkollAPIModel.CashReconciliationItemCategory.Other
      )
    );

    def = {
      ...salesItems,
      ...paymentMethodItems,
      ...otherItems,
      saleTotal: LocalizationHelperInstance.getFormattedCurrency(salesTotal, CurrencyEnums.CurrencyCode.SEK),
      paymentMethodsTotal: LocalizationHelperInstance.getFormattedCurrency(
        paymentMethodsTotal,
        CurrencyEnums.CurrencyCode.SEK
      ),
      otherTotal: LocalizationHelperInstance.getFormattedCurrency(otherTotal, CurrencyEnums.CurrencyCode.SEK),
    };
    return def;
  };

  return (
    <CashReconciliationDetailsForm
      ref={ref}
      {...props}
      defaultValues={getDefaultValues()}
      cashRegister={cashRegister}
    />
  );
};

export default forwardRef(CashReconciliationDetailsFormContainer);
